export const contactInfo = {
  phoneHref: "tel:+995595756175",
  phoneDisplay: "(+995) 595-75-61-75",
  emailHref: "mailto:gagachituashvili7@gmail.com",
  emailDisplay: "gagachituashvili7@gmail.com",
};
